@for (account of accounts() | sort: 'client.name'; track account.id) {
  <button
    mat-menu-item
    class="accountPicker_item"
    [ngClass]="{
      'selectedAccount': account.id === selectedAccountId()
    }"
    [attr.data-cy]="`${account.client?.name}-menu-option`"
    (click)="account.id !== selectedAccountId() && onAccountChange(account)"
  >
    <div class="d-flex w-100 align-items-center text-truncate">
      <div class="text-truncate">
        <div class="text-truncate" [title]="account.client?.name">
          {{ account.client?.name }}
        </div>

        @if (account.id === selectedAccountId()) {
          <div class="text-small text-muted">Active session</div>
        }
      </div>

      @if (account.client?.logoUrl) {
        <img
          class="accountPicker_logo ms-auto ps-1"
          [src]="account.client?.logoUrl"
          [alt]="account.client?.name"
        />
      } @else {
        <span class="ms-auto">&nbsp;</span>
      }
    </div>
  </button>
}
